import React from "react";
import { makeStyles } from "@material-ui/core";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import RootFooter from "../../../components/RootFooter";
import { RootTopBar } from "../../../components";

const customStyles = makeStyles({
    root: {
        padding: "100px 0px",
        width: "90%",
        maxWidth: "1216px",
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: "auto",
        fontFamily: "Manrope",
    },
    headerBtnWrapper: {
        display: "flex",
        marginTop: "50px",
        gap: "16px",
    },
    header: {
        margin: "26px 0px",
        color: "#271340",
        maxWidth: "50%",
        fontSize: "64px",
        fontWeight: 600,
        lineHeight: 1.1,
        fontFamily: "Manrope",
    },
});

const GuardLanding = () => {
    const classes = customStyles();
    const navigate = useNavigate();
    return (
        <>
            <RootTopBar />
            <div className={classes.root}>
                <h1 className={classes.header}>Guard Onboard</h1>

                <div className={classes.headerBtnWrapper}>
                    <div
                        className={"purpleBtn"}
                        style={{ textTransform: "none" }}
                        onClick={() => {
                            navigate(routes.GUARD_LOGIN);
                        }}
                    >
                        Login <ArrowForwardIcon />
                    </div>
                </div>
            </div>
            <RootFooter />
        </>
    );
};

export default GuardLanding;
